import { useEffect } from 'react';
import { processSilentLoginCallback } from './login-api';

const SilentLoginCallback = () => {
    useEffect(() => {
        processSilentLoginCallback();
    });

    return null;
};

export default SilentLoginCallback;
